import Header from "./components/Header";
import Hero from "./components/Hero";
import TrustBar from "./components/TrustBar";
import CtaBand from "./components/CtaBand";
import Price from "./components/Price";
import Flow from "./components/Flow";
import Services from "./components/Services";
import OneStop from "./components/OneStop";
import Cases from "./components/Cases";
import Reasons from "./components/Reasons";
import Area from "./components/Area";
import Company from "./components/Company";
import Faq from "./components/Faq";
import Contact from "./components/Contact";
import Instagram from "./components/Instagram";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <TrustBar />
        <Price />
        <Flow />
        <CtaBand />
        <Services />
        <OneStop />
        <Cases />
        <Reasons />
        <Area />
        <CtaBand
          eyebrow="片付けのあとのリフォームもご相談ください"
          title="片付けからリフォームまで、窓口ひとつで。"
          text="原状回復・クロス・床・屋根・外壁など、必要になった工事もそのままご相談いただけます。"
        />
        <Company />
        <Faq />
        <Contact />
        <Instagram />
      </main>
      <Footer />
    </div>
  );
}